import {
    LOAD_TRENDING_CATEGORIES_TAGS_EVENT,
    LOAD_TRENDING_HEADLINES_EVENT,
    LOAD_TRENDING_LOADING_EVENT,
    LOAD_TRENDING_TAGS_EVENT,
    LoadTagsTrending,
    LoadTagsTrendingCategories,
    LoadTweetTrendingCategory,
    LoadTweetTrendingHeadlines,
    LoadTweetTrendingLoading,
    SET_TAB_STATE_EVENT,
    SetTabState
} from "../../actions/trending/trending.actions";
import update from "immutability-helper";
import {TrendingItem} from "../../../model/TrendingItem";


export interface TrendingReducerState {
    trendingNews: TrendingItem[],
    // main page data
    companyTags: TrendingItem[],
    showTags: TrendingItem[],
    peopleTags: TrendingItem[],
    categoryTags: TrendingItem[],
    loading: boolean,
    tabState: number,
    // trending page loaders
    loadedTrendingData: boolean,
    loadedPanelNewsData: boolean,
    loadedPanelTagsData: boolean,
    isLoadingCategories: boolean,
}

const trendingState = {
  trendingNews: [],
  /*regionNews: null,
  regionCompanyTags: {northAmerica: [], westEurope: [], latam: [], ausnz: [], asia: [], africa: [], mideast: []},
  regionShowTags: {northAmerica: [], westEurope: [], latam: [], ausnz: [], asia: [], africa: [], mideast: []},
  regionPeopleTags: {northAmerica: [], westEurope: [], latam: [], ausnz: [], asia: [], africa: [], mideast: []},
  trendingCategories: [],*/
  // main page data
  companyTags: [],
  showTags: [],
  peopleTags: [],
  categoryTags: [],
  loading: false,
  tabState: 0,
  // trending page loaders
  loadedTrendingData: false,
  loadedPanelNewsData: false,
  loadedPanelTagsData: false,
  isLoadingCategories: false,
}

export default function trendingReducer(state: TrendingReducerState = trendingState,
                                        action: LoadTweetTrendingCategory | LoadTweetTrendingLoading | LoadTagsTrending |
                                         LoadTweetTrendingHeadlines | SetTabState | LoadTagsTrendingCategories
): TrendingReducerState {
  switch (action.type) {
    case LOAD_TRENDING_LOADING_EVENT:
      return update(state, {
        loading: {$set: action.loading},
      })
    case LOAD_TRENDING_TAGS_EVENT:
      return update(state, {
        companyTags: {$set: action.companyTags},
        showTags: {$set: action.showTags},
        peopleTags: {$set: action.peopleTags},
      })
    case LOAD_TRENDING_HEADLINES_EVENT:
      return update(state, {
        trendingNews: {$set: action.headlines},
        loadedTrendingData: {$set: true},
      })
    case SET_TAB_STATE_EVENT:
      return update(state, {
         tabState: {$set: action.tabState},
      })
    case LOAD_TRENDING_CATEGORIES_TAGS_EVENT:
        return update(state, {
            categoryTags: {$set: action.categoryTags},
        })
    default:
      return state;
  }
}
